import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportingService } from '../../reporting.service';
import { ReportFolder } from '../../models/report-folder.model';
import { CheckForErrorsMessageComponent } from '../../../../shared-components/guards/check-for-errors/check-for-errors-message/check-for-errors-message.component';




@AutoUnsubscribe()
@Component({
    selector: 'AddReportFolder',
    templateUrl: './add-folder.component.html',
    styleUrls: ['./add-folder.component.css']
})

export class AddReportFolderComponent implements OnInit, OnDestroy {

    // private reportService: ReportingService;

    // @Output() deleteSnapshotEvent: EventEmitter<boolean> = new EventEmitter();

    // private snapshotToDelete: AutoRunSnapshot;

    // private _reportName: string;
    // private _autoRunDate: Date;

    // get reportName(): string {
    //     return this._reportName;
    // }

    // set reportName(value: string) {
    //     this._reportName = value;
    // }

    // get autoRunDate(): Date {
    //     return this._autoRunDate;
    // }

    // set autoRunDate(value: Date) {
    //     this._autoRunDate = value;
    // }

    folderName: string;
    folderDescription: string;
    isFolderEdit: boolean;
    reportFolder: ReportFolder;
    ReportFolderToEdit: ReportFolder;
    isDirty: boolean;


    constructor(
        private reportService: ReportingService,
        private dialogRef: MatDialogRef<AddReportFolderComponent>,
        private dialog: MatDialog

    ) {

        this.isFolderEdit = this.reportService.isFolderEdit;
        this.ReportFolderToEdit = this.reportService.ReportFolderToEdit;

        if (this.isFolderEdit) {

            this.folderName = this.ReportFolderToEdit.Name;
            this.folderDescription = this.ReportFolderToEdit.Description;
        }


        if (this.reportService.inDebugMode) {
            console.log('AddReportFolderComponent > isFolderEdit: ' + this.isFolderEdit.toString());
        }
        // this.snapshotToDelete = reportService.autoRunSnapshot;

        // this.autoRunDate = this.snapshotToDelete.TimeStamp;
        // this.reportName = this.snapshotToDelete.ReportName;
    }

    ngOnInit() {
        this.isDirty = false;
    }

    saveReportFolderClick() {
        // they must enter a folder name to pass validation
        if (typeof this.folderName === 'undefined') {
            return;
        }

        let folderAlreadyExists = false;
        for (let i; i < this.reportService.ReportFolders.length; i++) {
            if (this.reportService.ReportFolders[i].Name.toLowerCase() == this.folderName.toLowerCase()) {
                folderAlreadyExists = true;
                break;
            }
        }
        if (!folderAlreadyExists) {

            if (this.reportService.inDebugMode) {
                console.log('saveReportFolderClick()');
            }

            // avoid printing 'undefined' as folder desc
            if (typeof this.folderDescription === 'undefined') {
                this.folderDescription = '';
                // return;
            }

            // if (typeof this.folderDescription == 'undefined' || this.folderDescription == '') {
            //     // this.folderDescription = '';
            //     return;

            // }

            const newReportFolder = new ReportFolder();
            newReportFolder.Name = this.folderName;
            newReportFolder.Description = this.folderDescription;
            newReportFolder.Id = -1;

            this.reportService.saveReportFolder(newReportFolder).subscribe(res => {

                if (this.reportService.inDebugMode) {
                    console.log(res);
                }
            });
        }

        this.dialogRef.close(true); // true to refreshFolders


    }

    saveEditClick() {

        // they must enter a folder name to pass validation
        if (typeof this.folderName === 'undefined') {
            return;
        }

        let folderAlreadyExists = false;
        for (let i = 0; i < this.reportService.ReportFolders.length; i++) {
            if (this.reportService.ReportFolders[i].Name.toLowerCase() == this.folderName.toLowerCase()) {
                folderAlreadyExists = true;
                break;
            }
        }
        if (!folderAlreadyExists) {

            if (this.reportService.inDebugMode) {
                console.log('saveEditClick()');
                console.log('folderName');
                console.log(this.folderName);
                console.log('folderDescription');
                console.log(this.folderDescription);

            }

            // avoid printing 'undefined' as folder desc
            if (typeof this.folderDescription === 'undefined') {
                this.folderDescription = '';
                // return;
            }

            if (this.folderDescription == 'null' || this.folderDescription == null) {
                this.folderDescription = '';
            }

            // if (typeof this.folderDescription == 'undefined' || this.folderDescription == '') {
            //     // this.folderDescription = '';
            //     return;

            // }

            this.ReportFolderToEdit.Name = this.folderName;
            this.ReportFolderToEdit.Description = this.folderDescription;


            this.reportService.saveReportFolder(this.ReportFolderToEdit).subscribe(res => {

                if (this.reportService.inDebugMode) {
                    console.log(res);
                }
            });
        }

        this.dialogRef.close(true); // true to refreshFolders


    }
    checkIsDirty() {

        if (this.reportService.inDebugMode) {
            console.log('folderName: ' + this.folderName);
            console.log('folderDesc: ' + this.folderDescription);
        }

        if (this.isFolderEdit) {
            if (this.folderName != this.ReportFolderToEdit.Name || this.folderDescription != this.ReportFolderToEdit.Description) {

                this.isDirty = true;


            }
        } else { // not edit
            if (typeof this.folderDescription === 'undefined' && typeof this.folderName === 'undefined') {

                this.isDirty = false;

            } else {
                this.isDirty = true;
            }
        }
    }


    cancelClick() {

        this.checkIsDirty();

        if (this.reportService.inDebugMode) {
            console.log('isDirty: ' + this.isDirty.toString());
        }

        if (this.isDirty) {

            const dialog = this.dialog.open(CheckForErrorsMessageComponent, {
                disableClose: true,
                data: {
                    errors: []
                }
            });

            dialog.componentInstance.dialogBox = dialog;
            dialog.afterClosed().subscribe(result => {
                console.log(result);
                switch (result) {
                    case 1: { // determine if edit or new folder > save and continue
                        if (this.isFolderEdit) {
                            this.saveEditClick();
                        } else if (!this.isFolderEdit) {
                            this.saveReportFolderClick();
                        }
                        break;
                    }
                    case 0: { // continue without save
                        this.dialogRef.close(false);
                        break;
                    }
                    case -1: { // cancel
                        break;
                    }
                    default: {
                        break;
                    }
                }
            });

        }
        else { // no unsaved changes
            this.dialogRef.close(false); // true to refreshFolders
        }


    }

    ngOnDestroy() {
    }

}